var $ = require('jquery');

module.exports = function(el) {
    var $el = $(el),
        $body = $('body'),
        $navTrigger = $el.find('.site-header__mobile-menu__nav-trigger'),
        $nav = $el.find('.site-header__menu-wrap'),
        navActiveClass = 'site-header__menu-wrap--active',
        navActive = false;

    function openNav() {
        $nav.addClass(navActiveClass);
        $body.addClass('menu-open');
        navActive = true;
    };

    function closeNav() {
        $nav.removeClass(navActiveClass);
        $body.removeClass('menu-open');
        navActive = false;
    };

    $navTrigger.on('click', function() {
        if (!navActive) {
            openNav();
        } else {
            closeNav();
        }
    });

    $(window).on('resize', closeNav);
}



//////////////////
// WEBPACK FOOTER
// ./modules/mobileNav.js
// module id = 7
// module chunks = 0